import { createSelector, createReducer } from '@reduxjs/toolkit';
import {
  FIELDTYPESPECIFICATION_INCLUDE,
  FIELDTYPESPECIFICATION_TYPE,
} from '../../constants/api';
import {
  getAllHearingTemplatesSuccess,
  getAllHearingsSuccess,
  getHearingSuccess,
  getPaginatedHearingsSuccess,
} from '../actions/api';
import { updateDtoList } from '../helpers/reducerHelpers';

import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';

// -------- Overview --------

// FieldTypeSpecification is included in the following endpoints
//  - ???

// -------- Reducer --------
const fieldTypeSpecificationReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypeSpecifications = data.filter(
          (include) => include.type === FIELDTYPESPECIFICATION_INCLUDE,
        );
        return updateDtoList(state, 'all', fieldTypeSpecifications);
      })
      .addCase(getHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypeSpecifications = data.filter(
          (include) => include.type === FIELDTYPESPECIFICATION_INCLUDE,
        );
        return updateDtoList(state, 'all', fieldTypeSpecifications);
      })
      .addCase(getAllHearingTemplatesSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypeSpecifications = data.filter(
          (include) => include.type === FIELDTYPESPECIFICATION_TYPE,
        );
        return updateDtoList(state, 'all', fieldTypeSpecifications);
      })
      .addCase(getPaginatedHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const fieldTypeSpecifications = data.filter(
          (include) => include.type === FIELDTYPESPECIFICATION_INCLUDE,
        );
        return updateDtoList(state, 'all', fieldTypeSpecifications);
      });
  },
);

// -------- Selectors --------
const selectGetAllFieldTypeSpecifications = (state) =>
  selectAllFromApiState(state, 'fieldTypeSpecification');
const allFieldTypeSpecificationsSelector = createSelector(
  selectGetAllFieldTypeSpecifications,
  (fieldTypeSpecifications) => fieldTypeSpecifications,
);

// -------- Exporting --------
export { allFieldTypeSpecificationsSelector };
export default fieldTypeSpecificationReducer;
